import { useEffect, useMemo, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { type Container } from "@tsparticles/engine";
// import { loadAll } from "@/tsparticles/all"; // if you are going to use `loadAll`, install the "@tsparticles/all" package too.
// import { loadFull } from "tsparticles"; // if you are going to use `loadFull`, install the "tsparticles" package too.
import { loadSlim } from "@tsparticles/slim"; // if you are going to use `loadSlim`, install the "@tsparticles/slim" package too.

export default function ConstParticles({show} : any ) {
  const [init, setInit] = useState(false);
  
  
  // this should be run only once per ConstParticleslication lifetime
  useEffect(() => {
    initParticlesEngine(async (engine) => {
     
      await loadSlim(engine);
      //await loadBasic(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  const particlesLoaded = async (container?: Container): Promise<void> => {
    console.log(container);
  };
  const options : any = useMemo(
    () => ({
          fpsLimit: 60,
    backgroundMode: {
      enable: false,
      zIndex: 0
    },
    particles: {
      number: {
        value: 80,
      },
      color: {
        value: "#e3c37a",
      },
      shape: {
        type: "star",
      },
      stroke: {
        width: 0
      },
      opacity: {
        value: 1,
      },
      size: {
        value: 3,
      },
      links: {
        enable: true,
        distance: 150,
        color: "#e3c37a",
        opacity: 1,
        width: 1,
      },
      move: {
        collisions: {
          enable: true,
          mode: "absorb",
        },
        enable: true,
        speed: 0.5,
        direction: "none",
        outMode: "bounce",
      }
    },
    interactivity: {
      detectsOn: "canvas",
      events: {
        resize: true,
      },
    },
    detectRetina: true,
  }), []);
  

  if (init) {
    return <Particles className={`${show}`}  id="tsparticles2" particlesLoaded={particlesLoaded} options={options} />;
  }

  return <></>;
};